import { render, staticRenderFns } from "./dySearch.vue?vue&type=template&id=35bc9036&scoped=true"
import script from "./dySearch.vue?vue&type=script&lang=js"
export * from "./dySearch.vue?vue&type=script&lang=js"
import style0 from "./dySearch.vue?vue&type=style&index=0&id=35bc9036&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bc9036",
  null
  
)

export default component.exports